import $axios from '@/axios-instance.js'

export const priceListDefaultService = {
  getListData,
  getById,
  getLatest,
  create,
  update,
  delete: _delete
}

function getListData (filter, page) {
  return $axios.get(`${process.env.ROOT_API}/price-lists-default`, { params: Object.assign({ currentPage: page }, filter) }).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/price-lists-default/${id}`).then(response => {
    return response.data
  })
}

function getLatest () {
  console.log('service start')
  return $axios.get(`${process.env.ROOT_API}/price-lists-default/get-latest`).then(response => {
    console.log('service end')
    return response.data
  })
}

function create (priceList) {
  return $axios.post(`${process.env.ROOT_API}/price-lists-default`, priceList).then(response => {
    return response.data
  })
}

function update (priceList) {
  return $axios.put(`${process.env.ROOT_API}/price-lists-default/${priceList.priceListDefaultId}`, priceList).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/price-lists-default/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/price-list-default.service.js